import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import IndividualsImportWizard from "./IndividualsImportWizard/IndividualsImportWizard";

const IndividualsImportModal: React.FC<{
  isOpen: boolean;
  toggle: () => void;
  onImported?: () => void;
}> = ({ isOpen, toggle, onImported }) => (
  <Modal
    id="individuals-import-modal"
    size="xl"
    isOpen={isOpen}
    toggle={toggle}
    centered
    className="data-import-modal"
  >
    <ModalHeader className="p-3 border-bottom" toggle={toggle}>
      <div className="d-flex align-items-center gap-3">
        <div
          className="rounded-2 d-flex align-items-center justify-content-center flex-shrink-0 bg-secondary-subtle"
          style={{ width: 42, height: 42 }}
        >
          <i className="ri-user-line text-secondary" style={{ fontSize: 22 }} />
        </div>
        <div>
          <div className="fw-semibold" style={{ fontSize: 16, lineHeight: 1.3 }}>
            Import Individuals
          </div>
          <div className="text-muted fw-normal" style={{ fontSize: 14, marginTop: 2 }}>
            Upload a CSV file to bulk-import individual records
          </div>
        </div>
      </div>
    </ModalHeader>
    <ModalBody className="p-4">
      {isOpen && <IndividualsImportWizard onImported={onImported} />}
    </ModalBody>
  </Modal>
);

export default IndividualsImportModal;
